var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polyline, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.49,29.38c-8.64,3.07-18,7.73-26.48,10.69l-.22-.2c5.59-7.27,12-16.22,17.79-23.84A50.34,50.34,0,0,1,95.49,29.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.87,59.1C25.93,67,18.39,75.11,12.5,82.78a49.62,49.62,0,0,1-8.91-14.7C12.43,65.3,22.85,61.94,31.87,59.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.52,68.17a50,50,0,0,1-9,14.8c-5.92-7.71-13.14-15.91-19.22-23.86C77.43,62,87.59,65.36,96.52,68.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.36,39.86l-.21.21c-8.44-2.86-18.69-6.11-27.23-9a50.31,50.31,0,0,1,8.49-13.77C18.17,24.71,25.69,32.49,31.36,39.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.83,12.4c-7.51,5.82-15.36,13.14-22.74,18.82l-.29-.17c3-8.54,6.39-18.72,9.31-27.15A50.07,50.07,0,0,1,82.83,12.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.33,69c-3,8.56-7,18.12-10.08,26.79a49.88,49.88,0,0,1-13.54-8.71C24.32,81.2,32.64,74.5,40.05,68.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.13,31.08l-.26.17C32.46,25.55,24.22,18.79,16.67,13a49.77,49.77,0,0,1,13.48-8.7C33.27,13,37.1,22.55,40.13,31.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.24,87.23a49.88,49.88,0,0,1-13,8.41C66.92,87.06,63,77.4,59.84,69l.31-.19C67.54,74.47,75.68,81.44,83.24,87.23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.55,97.42A50.1,50.1,0,0,1,53,99.78C54.12,91,54.85,80.72,56,72.43l.32-.09C59.21,79.89,62.54,89.54,65.55,97.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.26,99.79a49.86,49.86,0,0,1-12.17-2.21c2.85-8,6-17.59,8.76-25.4l.32,0C45.31,80.73,46.13,90.88,47.26,99.79Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.29.21c-1.11,8.87-2,19.12-3.11,27.55l-.31.09C41.09,20.1,38,10.39,35.2,2.39A49.75,49.75,0,0,1,47.29.21Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.87,47.44C91,46.32,80.55,45.21,72.28,44.11c0-.1,0-.2-.08-.3,7.63-2.66,17.68-5.31,25.68-8A49.23,49.23,0,0,1,99.87,47.44Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65,2.42C62.27,10.37,59,20,56.3,27.57l-.33,0c-1.12-8.3-1.61-18.48-2.66-27.3A50,50,0,0,1,65,2.42Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.62,43.77v.35C19.62,45.19,9,46.2.28,47.27A49.67,49.67,0,0,1,2.21,36C10.12,38.59,20.28,41.21,27.62,43.77Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.13,56c-6.75,2.15-17.19,5.13-25.06,7.54A49.12,49.12,0,0,1,.36,53.86c8.64.7,19.38.86,26.68,1.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.88,52.44a49.81,49.81,0,0,1-1.71,10.78c-7.85-2.38-17.6-4.66-25.23-7l0-.3C81.12,54.78,91.2,53.6,99.88,52.44Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "31.09 40.05 31.77 40.3 31.27 39.74 31.09 40.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "39.87 31.25 40.28 31.54 40.13 31.09 39.87 31.25"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "43.87 27.85 44.07 28.32 44.18 27.76 43.87 27.85"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "55.89 26.98 56.05 28.21 56.3 27.57 55.89 26.98"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "60.09 31.22 59.48 31.8 59.81 31.05 60.09 31.22"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "69.01 40.07 68.44 40.35 68.79 39.87 69.01 40.07"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "72.28 44.11 71.55 43.99 72.2 43.81 72.28 44.11"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "72.94 56.2 71.86 55.96 72.96 55.9"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "59.84 69.02 59.54 68.35 60.15 68.83 59.84 69.02"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "56.29 72.34 55.98 71.35 55.97 72.43 56.29 72.34"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "44.17 72.21 44.16 71.34 43.85 72.18 44.17 72.21"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "40.33 68.98 40.68 68.37 40.05 68.8 40.33 68.98"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "27.13 56.01 27.85 55.79 27.04 55.66 27.13 56.01"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "27.61 44.12 28.41 44.1 27.61 43.77 27.61 44.12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.82,50c3.6-1.21,6.39-3,10.16-2.27,5.19,1.06,10.52,1.44,15.83,2.43l-2,.27c-5.12.68-10.25,1.41-15.39,2a10.5,10.5,0,0,1-3.83-.52C59.12,51.44,57.7,50.74,55.82,50Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.92,54c3.39,1.71,6.64,2.42,8.75,5.64,2.89,4.44,6.36,8.5,9.38,13l-1.58-1.21c-4.08-3.18-8.2-6.31-12.21-9.57a10.4,10.4,0,0,1-2.33-3.1C55.19,57.33,54.7,55.83,53.92,54Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.75,55.4c1.16,3.61,2.94,6.43,2.12,10.19-1.12,5.18-1.58,10.5-2.63,15.79-.09-.66-.18-1.32-.25-2-.61-5.14-1.28-10.27-1.77-15.42a10.34,10.34,0,0,1,.57-3.83C48.24,58.68,49,57.27,49.75,55.4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M45.79,53.44C44,56.81,43.28,60.06,40,62.11c-4.48,2.84-8.58,6.25-13.09,9.22.41-.53.81-1,1.23-1.57,3.23-4,6.42-8.12,9.73-12.08A10.25,10.25,0,0,1,41,55.39C42.4,54.67,43.91,54.2,45.79,53.44Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.41,49.25c-3.63,1.11-6.48,2.86-10.22,2C29,50.05,23.71,49.52,18.44,48.39l2-.22c5.15-.54,10.29-1.14,15.44-1.56a10.28,10.28,0,0,1,3.82.62C41.15,47.7,42.55,48.44,44.41,49.25Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.42,45.33c-3.34-1.81-6.58-2.61-8.6-5.88-2.77-4.52-6.13-8.67-9-13.22l1.55,1.25c4,3.29,8,6.53,12,9.9a10.24,10.24,0,0,1,2.24,3.16A51.08,51.08,0,0,1,46.42,45.33Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.63,44c-1.07-3.65-2.77-6.51-1.85-10.25C50,28.61,50.64,23.3,51.84,18c.06.66.13,1.32.19,2,.47,5.15,1,10.3,1.35,15.46a10.32,10.32,0,0,1-.67,3.81C52.22,40.76,51.46,42.15,50.63,44Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.53,46.06c1.84-3.31,2.69-6.54,6-8.51,4.55-2.72,8.75-6,13.34-8.86-.43.51-.85,1-1.28,1.53-3.34,4-6.63,8-10,11.82a10.5,10.5,0,0,1-3.19,2.2C58,44.92,56.43,45.36,54.53,46.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetIcon);
export default __webpack_public_path__ + "static/media/assetIcon.5853fa1a330a8b7e2690d726b7915b9b.svg";
export { ForwardRef as ReactComponent };